import { render, staticRenderFns } from "./WizardFooter.vue?vue&type=template&id=fe56da0e&scoped=true&"
import script from "./WizardFooter.vue?vue&type=script&lang=js&"
export * from "./WizardFooter.vue?vue&type=script&lang=js&"
import style0 from "./WizardFooter.vue?vue&type=style&index=0&id=fe56da0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe56da0e",
  null
  
)

export default component.exports